import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCompetitionCompetiteursStatistics } from "../../services/competiteursServices";
import { countCompetitionDistributions } from "../../services/distributionsServices";
import { countCompetitionCombats } from "../../services/combatsServices";
import {
  FaUserCheck,
  FaUsers,
  FaPercentage,
  FaClipboardList,
} from "react-icons/fa";
import { MdOutlineSportsKabaddi } from "react-icons/md";

const PublicStatisticsCard = ({ nombreClubs = 0 }) => {
  const { competition_id } = useParams();
  const [statistics, setStatistics] = useState(null);
  const [totalDistributions, setTotalDistributions] = useState(0);
  const [totalCombats, setTotalCombats] = useState(0);

  useEffect(() => {
    const fetchAllStats = async () => {
      try {
        const statsData = await getCompetitionCompetiteursStatistics(
          competition_id
        );
        setStatistics(statsData);

        const distRes = await countCompetitionDistributions(competition_id);
        setTotalDistributions(distRes?.count || 0);

        const combatsRes = await countCompetitionCombats(competition_id);
        setTotalCombats(combatsRes?.count || 0);
      } catch (error) {
        console.error(
          "Erreur lors du chargement des statistiques publiques :",
          error
        );
      }
    };

    fetchAllStats();
  }, [competition_id]);

  const totalInscrits = statistics?.total_inscrits || 0;
  const totalPresents = statistics?.total_presents || 0;
  const pourcentagePresence =
    totalInscrits > 0 ? ((totalPresents / totalInscrits) * 100).toFixed(2) : 0;

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-6 max-w-[1280px] mx-auto w-full px-2">
      <StatCard
        title="Judokas Inscrits"
        value={totalInscrits}
        icon={<FaUsers className="text-blue-500 text-3xl" />}
      />
      <StatCard
        title="Judokas Présents/Pesés"
        value={totalPresents}
        icon={<FaUserCheck className="text-green-500 text-3xl" />}
      />
      <StatCard
        title="% Présence"
        value={`${pourcentagePresence} %`}
        icon={<FaPercentage className="text-yellow-500 text-3xl" />}
      />
      <StatCard
        title="Distributions Créées"
        value={totalDistributions}
        icon={<FaClipboardList className="text-purple-500 text-3xl" />}
      />
      <StatCard
        title="Combats Réalisés"
        value={totalCombats}
        icon={<MdOutlineSportsKabaddi className="text-red-500 text-3xl" />}
      />
      <StatCard
        title="Clubs Participants"
        value={nombreClubs}
        icon={<FaClipboardList className="text-orange-500 text-3xl" />}
      />
    </div>
  );
};

const StatCard = ({ title, value, icon }) => (
  <div className="bg-white dark:bg-gray-800 shadow-lg p-6 rounded-lg flex items-center justify-between border border-gray-200 dark:border-gray-700 transition-all duration-300">
    <div>
      <h4 className="text-lg font-semibold text-gray-700 dark:text-white mb-1">
        {title}
      </h4>
      <p className="text-2xl font-bold text-gray-900 dark:text-gray-300">
        {value}
      </p>
    </div>
    <div>{icon}</div>
  </div>
);

export default PublicStatisticsCard;
